'use strict';

var _classCallCheck = require("C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/* eslint-env browser */


exports.default = createBrowserApp;

var _history = require('history');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _core = require('@react-navigation/core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable import/no-commonjs */


var queryString = require('query-string');

var getPathAndParamsFromLocation = function getPathAndParamsFromLocation(location) {
  var path = encodeURI(location.pathname.substr(1));
  var params = queryString.parse(location.search);
  return {
    path: path,
    params: params
  };
};

var matchPathAndParams = function matchPathAndParams(a, b) {
  if (a.path !== b.path) {
    return false;
  }

  if (queryString.stringify(a.params) !== queryString.stringify(b.params)) {
    return false;
  }

  return true;
};

function getHistory(history) {
  if (typeof history === 'string') {
    switch (history) {
      case 'browser':
        return (0, _history.createBrowserHistory)();

      case 'hash':
        return (0, _history.createHashHistory)();

      case 'memory':
        return (0, _history.createMemoryHistory)();

      default:
        throw new Error('@react-navigation/web: createBrowserApp() Invalid value for options.history ' + history);
    }
  }

  return history || (0, _history.createBrowserHistory)();
}

function createBrowserApp(App) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      historyOption = _ref.history;

  var history = getHistory(historyOption);
  var currentPathAndParams = getPathAndParamsFromLocation(history.location);

  var initAction = App.router.getActionForPathAndParams(currentPathAndParams.path, currentPathAndParams.params) || _core.NavigationActions.init();

  var setHistoryListener = function setHistoryListener(dispatch) {
    history.listen(function (location) {
      var pathAndParams = getPathAndParamsFromLocation(location);

      if (matchPathAndParams(pathAndParams, currentPathAndParams)) {
        return;
      }

      currentPathAndParams = pathAndParams;
      var action = App.router.getActionForPathAndParams(pathAndParams.path, pathAndParams.params);

      if (action) {
        dispatch(action);
      } else {
        dispatch(initAction);
      }
    });
  };

  var WebApp =
  /*#__PURE__*/
  function (_react2$default$Compo) {
    _inherits(WebApp, _react2$default$Compo);

    function WebApp() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, WebApp);

      var _temp;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WebApp)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
        nav: App.router.getStateForAction(initAction)
      }, _this._title = document.title, _this._actionEventSubscribers = new Set(), _this.dispatch = function (action) {
        var lastState = _this.state.nav;
        var newState = App.router.getStateForAction(action, lastState);

        var dispatchEvents = function dispatchEvents() {
          return _this._actionEventSubscribers.forEach(function (subscriber) {
            return subscriber({
              type: 'action',
              action: action,
              state: newState,
              lastState: lastState
            });
          });
        };

        if (newState && newState !== lastState) {
          _this.setState({
            nav: newState
          }, function () {
            _this._onNavigationStateChange(lastState, newState, action);

            dispatchEvents();
          });

          var pathAndParams = App.router.getPathAndParamsForState && App.router.getPathAndParamsForState(newState);

          if (pathAndParams && !matchPathAndParams(pathAndParams, currentPathAndParams)) {
            currentPathAndParams = pathAndParams;
            history.push("/".concat(pathAndParams.path, "?").concat(queryString.stringify(pathAndParams.params)));
          }
        } else {
          dispatchEvents();
        }
      }, _temp));
    }

    _createClass(WebApp, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        setHistoryListener(this.dispatch);
        this.updateTitle();

        this._actionEventSubscribers.forEach(function (subscriber) {
          return subscriber({
            type: 'action',
            action: initAction,
            state: _this2.state.nav,
            lastState: null
          });
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.updateTitle();
      }
    }, {
      key: "updateTitle",
      value: function updateTitle() {
        var state = this._navigation.state;
        var childKey = state.routes[state.index].key;

        var activeNav = this._navigation.getChildNavigation(childKey);

        var opts = App.router.getScreenOptions(activeNav);
        this._title = opts.title || opts.headerTitle;

        if (this._title) {
          document.title = this._title;
        }
      }
    }, {
      key: "_onNavigationStateChange",
      value: function _onNavigationStateChange(prevNav, nav, action) {
        if (typeof this.props.onNavigationStateChange === 'function') {
          this.props.onNavigationStateChange(prevNav, nav, action);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        this._navigation = (0, _core.getNavigation)(App.router, this.state.nav, this.dispatch, this._actionEventSubscribers, function () {
          return _this3.props.screenProps;
        }, function () {
          return _this3._navigation;
        });
        return _react2.default.createElement(_core.NavigationProvider, {
          value: this._navigation
        }, _react2.default.createElement(App, _extends({}, this.props, {
          navigation: this._navigation
        })));
      }
    }]);

    return WebApp;
  }(_react2.default.Component);

  return WebApp;
}